import { Action, ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromCustomerConfig from './customer';
import * as fromMenuList from './menu';
import * as fromSsoLinks from './sso';
import * as fromAvailability from './reducers-availability';
import * as fromCartWidget from './cart-widget';
import * as fromPermissions from './reducers-permission';
import * as fromLoyaltyTile from './reducers-loyalty-tile';
import * as fromBannerTile from './reducers-banner-tile';

import * as fromContactUs from './reducers-contact';
import * as fromNews from './news';
import * as fromContentPage from './reducers-content';
import * as fromAgent from './loyalty/reducers-agent';
import * as fromAccount from './loyalty/reducers-account';
import * as fromBonusPoints from './loyalty/reducers-bonus-points';
import * as fromStatusPoints from './loyalty/reducers-status-points';
import * as fromCustomer from './loyalty/reducers-customer';
import * as fromParticipation from './loyalty/reducers-participation';

import { Customer, Stores } from '../models/customer';

import { AgentState } from '../models/loyalty/agent.state';
import { AccountState } from '../models/loyalty/account.state';
import { BonusPointsState } from '../models/loyalty/bonus-points.state';
import { CustomerState } from '../models/loyalty/customer.state';
import { ParticipationState } from '../models/loyalty/participation.state';

import * as fromAgency from './account/reducers-agency';
import * as fromProfile from './account/reducers-profile';
import * as fromContracts from './account/reducers-contracts';
import * as fromOrders from './account/reducers-orders';
import * as fromInventory from './account/reducers-inventory';

import { InvoicesState, reducersInvoices } from './invoices/reducers-invoices';
import { reducer as segmentsConfigReducer, State as SegmentsConfigState } from './invoices/reducers-segments-config';
import { reducer as segmentsReportReducer, State as SegmentsReportState } from './invoices/reducers-segments-report';
import { reducer as segmentsOptionsReducer, State as SegmentsOptionsState } from './invoices/reducers-segments-options';

import * as fromDashboard from './dashboard/reducers-dashboard';

import { AgencyState } from '../models/account/agency.state';
import { ProfileState } from '../models/account/profile.state';
import { OrdersState } from '../models/account/orders.state';
import { WishlistsState } from '../models/account/wishlists.state';
import { WishlistsDetailsState } from '../models/account/detailed-wishlist.state';
import { ContractsState } from '../models/account/contracts.state';
import { InventoryState } from '../models/account/inventory.state';

import * as fromModularityConfig from './reducers-modularity';
import { IBookModuleConfig } from '../models/book/module-config';
import { StatusPointsState } from '../models/loyalty/status-points.state';
import { AvcInvoicesState, reducersAvcInvoices } from './../../components/account/avc-invoices/redux/reducers/reducers-avc-invoices';

export interface State {
  tile_news: fromNews.State;
  customer: fromCustomerConfig.State;
  menu: fromMenuList.State;
  sso: fromSsoLinks.State;
  availability: fromAvailability.State;
  contactUs: fromContactUs.State;
  page: fromContentPage.State;

  agent: AgentState;
  account: AccountState;
  bonuspoints: BonusPointsState;
  statuspoints: StatusPointsState;
  loyaltyCustomer: CustomerState;
  participation: ParticipationState;

  agency: AgencyState;
  profile: ProfileState;
  contracts: ContractsState;
  orders: OrdersState;
  inventory: InventoryState;

  invoices: InvoicesState;
  avcInvoices: AvcInvoicesState;
  segmentsConfig: SegmentsConfigState;
  segmentsReport: SegmentsReportState;
  segmentsOptions: SegmentsOptionsState;

  dashboard: fromDashboard.State;

  modules: fromModularityConfig.State;

  widget_cart: fromCartWidget.State;
  permission: fromPermissions.State;

  loyaltyTile: fromLoyaltyTile.State;
  bannerTile: fromBannerTile.State;
}

export const reducers: ActionReducerMap<State> = {
  tile_news: fromNews.reducer,
  customer: fromCustomerConfig.reducer,
  menu: fromMenuList.reducer,
  sso: fromSsoLinks.reducer,
  availability: fromAvailability.reducer,
  contactUs: fromContactUs.reducer,
  page: fromContentPage.reducer,

  agent: fromAgent.reducersAgent,
  account: fromAccount.reducersAccount,
  bonuspoints: fromBonusPoints.reducersBonusPoints,
  statuspoints: fromStatusPoints.reducersStatusPoints,
  loyaltyCustomer: fromCustomer.reducersCustomer,
  participation: fromParticipation.reducersParticipation,

  agency: fromAgency.reducersAgency,
  profile: fromProfile.reducersProfile,
  contracts: fromContracts.reducersContracts,
  orders: fromOrders.reducersOrders,
  inventory: fromInventory.reducersInventory,

  invoices: reducersInvoices,
  avcInvoices: reducersAvcInvoices,
  segmentsConfig: segmentsConfigReducer,
  segmentsReport: segmentsReportReducer,
  segmentsOptions: segmentsOptionsReducer,

  dashboard: fromDashboard.reducer,

  modules: fromModularityConfig.reducer,

  widget_cart: fromCartWidget.reducer,
  permission: fromPermissions.reducer,

  loyaltyTile: fromLoyaltyTile.reducer,
  bannerTile: fromBannerTile.reducer
};

export const homepageSelector = createFeatureSelector<any>('homepage');

const availabilityState = state => state.availability;
const customerConfigState = state => state.customer;
const menuListState = state => state.menu;
const ssoState = state => state.sso;
const contactInfoState = state => state.contactUs;
const contentPageState = state => state.page;
const cartWidgetState = state => state.widget_cart;
const permissionState = state => state.permission;
const loyaltyTileState = state => state.loyaltyTile;
const bannerTileState = state => state.bannerTile;

const agentState = state => state.agent;
const accountState = state => state.account;
const customerProfileState = state => state.loyaltyCustomer;
const bonusPointsState = state => state.bonuspoints;
const statusPointsState = state => state.statuspoints;
const participationState = state => state.participation;

const agencyState = state => state.agency;
const profileState = state => state.profile;
const contractsState = state => state.contracts;
const inventoryState = state => state.inventory;

// const customerConfigState = state => state.homepage && state.homepage.customer;
// export const getCustomerConfigState = createSelector(customerConfigState);

export const getAvailabilityState = createSelector(homepageSelector, availabilityState);
export const getCustomerConfigState = createSelector(homepageSelector, customerConfigState);
export const getMenuListState = createSelector(homepageSelector, menuListState);
export const getSsoLinksState = createSelector(homepageSelector, ssoState);
export const getContactInfoState = createSelector(homepageSelector, contactInfoState);
export const getContentPageState = createSelector(homepageSelector, contentPageState);
export const getCartWidgetState = createSelector(homepageSelector, cartWidgetState);

export const getAgencyInfo = createSelector(homepageSelector, agencyState);
export const getProfileInfo = createSelector(homepageSelector, profileState);
export const getContractsInfo = createSelector(homepageSelector, contractsState);
export const getInventoryInfo = createSelector(homepageSelector, inventoryState);
export const getCustomerConfigInfo = createSelector(homepageSelector, customerConfigState);
export const getPermissionState = createSelector(homepageSelector, permissionState);

export const getLoyaltyTileState = createSelector(homepageSelector, loyaltyTileState);
export const getBannerTileState = createSelector(homepageSelector, bannerTileState);

export const getAgentState = createSelector(
  homepageSelector,
  agentState
);
export const getAccountState = createSelector(
  homepageSelector,
  accountState
);
export const getCustomerProfileState = createSelector(
  homepageSelector,
  customerProfileState
);
export const getBonusPointsState = createSelector(
  homepageSelector,
  bonusPointsState
);

export const getStatusPointsState = createSelector(
  homepageSelector,
  statusPointsState
);

export const getParticipationState = createSelector(homepageSelector, participationState);
export const getParticipationIsApprove = createSelector(
  getParticipationState,
  (state: ParticipationState) => state.isApprove
);
export const getParticipationIsRequest = createSelector(
  getParticipationState,
  (state: ParticipationState) => state.isRequest
);

export const getCustomerConfig = createSelector(
  getCustomerConfigState,
  (v: fromCustomerConfig.State) => v.customerConfig
);

export const getCustomerDefaultStoreCode = createSelector(
  getCustomerConfig,
  (customer: Customer) => customer.default_store_code
);

export const getCustomerStores = createSelector(getCustomerConfig, (customer: Customer) => customer.stores);

export const getCustomerLocale = createSelector(
  getCustomerDefaultStoreCode,
  getCustomerStores,
  (defaultStoreCode: string, stores: Stores[]) => {
    const defaultStore = stores ? stores.find((store: Stores) => store.store_code === defaultStoreCode) : null;
    return defaultStore ? defaultStore.locale : null;
  }
);

export const newsState = state => state.homepage.tile_news;

export const getNewsState = createSelector(newsState, (v: fromNews.State) => ({
  data: v
}));

/* eslint-disable */
export const __config = createSelector(homepageSelector, (state: any) => state.modules);

/* eslint-disable */
export const __config_analytics = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.analytics
}));

/* eslint-disable */
export const __config_catalog = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.catalog
}));

/* eslint-disable */
export const __config_contact = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.contact
}));

/* eslint-disable */
export const __config_dashboard = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.dashboard
}));

/* eslint-disable */
export const __config_inventory = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.inventory
}));

/* eslint-disable */
export const __config_invoice = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.invoice
}));

/* eslint-disable */
export const __config_loyalty = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.loyalty
}));

/* eslint-disable */
export const __config_order = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.order
}));

/* eslint-disable */
export const __config_profile = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.profile
}));

export const modules = createSelector(homepageSelector, (state: any) => state.modules);
const moduleConfigs = createSelector(modules, (state: any) => state.configs);
const isLoading = createSelector(modules, (state: any) => state.isLoading);
const secoPiloting = createSelector(moduleConfigs, state => state && state.seco_piloting);
const secoUrl = createSelector(secoPiloting, state => state && state.seco_url);

export const moduleConfig = (props: { name: string }) =>
  createSelector(modules, (state: any) => ({
    isLoading: state.isLoading,
    config: state.configs[props.name]
  }));

/* eslint-disable */
export const __config_seco_piloting = createSelector(isLoading, secoUrl, (loading: boolean, url: any) => ({
  isLoading: loading,
  secoUrl: url
}));

/* eslint-disable */
export const __config_social_links = createSelector(homepageSelector, (state: any) => ({
  isLoading: state.modules.isLoading,
  config: state.modules.configs.social_links
}));

/* eslint-disable */
export const __config_book = createSelector(isLoading, modules, (loading: boolean, state: any) => ({
  isLoading: loading,
  config: state.configs.search_and_book as IBookModuleConfig
}));

/* eslint-disable */
export const __config_layout = createSelector(isLoading, modules, (loading: boolean, state: any) => ({
  isLoading: loading,
  config: state.configs.layout
}));

// export const __config_catalog       = createSelector((state: any) => state.homepage.modules.configs.catalog);
// export const __config_contact       = createSelector((state: any) => state.homepage.modules.configs.contact);
// export const __config_dashboard     = createSelector((state: any) => state.homepage.modules.configs.dashboard);
// export const __config_inventory     = createSelector((state: any) => state.homepage.modules.configs.inventory);
// export const __config_invoice       = createSelector((state: any) => state.homepage.modules.configs.invoice);
// export const __config_loyalty       = createSelector((state: any) => state.homepage.modules.configs.loyalty);
// export const __config_order         = createSelector((state: any) => state.homepage.modules.configs.order);
// export const __config_profile       = createSelector((state: any) => state.homepage.modules.configs.profile);
// export const __config_social_links  = createSelector((state: any) => state.homepage.modules.configs.social_links);

// TODO eloqua for registration
// export const getRegistrationInfoForEloqua = createSelector(
//   __config_contact,
//   registrationStateFirstStep,
//   (modularContactConfig: {isLoading: boolean, config: any}, regStateFirstStep: fromRegistrationFirstStep.State) => {
//     return {
//       EmailAddress: regStateFirstStep.contact_email,
//       dynamicOrganization: modularContactConfig.config.name, //ACO name
//     }
//   }
// );

export const getInfoForLoyaltyEloqua = createSelector(
  __config_contact,
  __config_analytics,
  getCustomerProfileState,
  (
    modularContactConfig: { isLoading: boolean; config: any },
    modularAnalyticsConfig: { isLoading: boolean; config: any },
    v: any
  ) => ({
    EmailAddress: v.contact_email !== undefined ? (typeof v.contact_email === 'string' ? v.contact_email : v.contact_email.value) : '',
    dynamicOrganization: modularAnalyticsConfig.config.organization_name
  })
);

// Invoices
export const invoicesSelector = createSelector(homepageSelector, (state: State) => state.invoices);
export const getSegmentsConfig = createSelector(homepageSelector, (state: State) => state.segmentsConfig);
export const getSegmentsReport = createSelector(homepageSelector, (state: State) => state.segmentsReport);
export const getSegmentsOptions = createSelector(homepageSelector, (state: State) => state.segmentsOptions);
export const avcInvoicesSelector = createSelector(homepageSelector, (state: State) => state.avcInvoices);

export interface SegmentsState {
  config: SegmentsConfigState;
  options: SegmentsOptionsState;
  report: SegmentsReportState;
}

// Dashboard
export const getDashboard = createSelector(homepageSelector, (state: State) => state.dashboard);
export const getDashboardOptions = createSelector(getDashboard, (state: fromDashboard.State) => state.options);
export const getDashboardReport = createSelector(getDashboard, (state: fromDashboard.State) => state.report);

export const getDashboardCombined = createSelector(
  getDashboard,
  __config_dashboard,
  (dashboard: fromDashboard.State, config: fromDashboard.Config) => ({
    config,
    options: dashboard.options,
    report: dashboard.report
  })
);

// Orders
export const getOrdersInfo = createSelector(homepageSelector, (state: State) => state.orders);

export const selectAVCTACurrency = createSelector(
  (state: any) => state.homepage.customer.customerConfig,
  (customerConfig: any) => customerConfig?.avc_ta_currency
);